$(document).ready(function() {

  function ShoppingPerksSlider() {
    if ($(window).width() <= 767) {
      if (!$('.shopping-perks-mob-slider').hasClass('slick-initialized')) {
        $('.shopping-perks-mob-slider').slick({
          infinite: false,
          autoplay: true,
          autoPlaySpeed: 3000,
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: "<div class='pre-btn'><svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'><g clip-path='url(#clip0_0_662)'><path d='M15 6.66992L9 12.6699L15 18.6699' stroke='#FF4C45' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></g><defs><clipPath id='clip0_0_662'><rect width='24' height='24' fill='white' transform='matrix(-1 0 0 1 24 0.669922)'/></clipPath></defs></svg></div>",
          nextArrow: "<div class='pre-btn next-btn'><svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'><g clip-path='url(#clip0_0_666)'><path d='M9 6.66992L15 12.6699L9 18.6699' stroke='#FF4C45' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></g><defs><clipPath id='clip0_0_666'><rect width='24' height='24' fill='white' transform='translate(0 0.669922)'/></clipPath></defs></svg></div>"
        });
      }
    } else {
      if ($('.shopping-perks-mob-slider').hasClass('slick-initialized')) {
        $('.shopping-perks-mob-slider').slick('unslick');
      }
    }
  }

  function related(){
    if ($(window).width() <= 767) {
      if (!$('.realted-slider').hasClass('slick-initialized')) {
        $('.realted-slider').slick({
          infinite: false,
          autoplay: true,
          autoPlaySpeed: 3000,
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: "<div class='pre-btn'><svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'><g clip-path='url(#clip0_0_662)'><path d='M15 6.66992L9 12.6699L15 18.6699' stroke='#FF4C45' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></g><defs><clipPath id='clip0_0_662'><rect width='24' height='24' fill='white' transform='matrix(-1 0 0 1 24 0.669922)'/></clipPath></defs></svg></div>",
          nextArrow: "<div class='pre-btn next-btn'><svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'><g clip-path='url(#clip0_0_666)'><path d='M9 6.66992L15 12.6699L9 18.6699' stroke='#FF4C45' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></g><defs><clipPath id='clip0_0_666'><rect width='24' height='24' fill='white' transform='translate(0 0.669922)'/></clipPath></defs></svg></div>"
        });
      }
    } else {
      if ($('.realted-slider').hasClass('slick-initialized')) {
        $('.realted-slider').slick('unslick');
      }
    }
  }

  //ShoppingPerksSlider();
  related();
  
  $('.product_slider').slick({
    infinite: false,
    prevArrow: '<button class="fa fa-angle-left"></button>',
    nextArrow: '<button class="fa fa-angle-right"></button>',
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    vertical: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.btn-minus').on('click', function() {
    var $input = $(this).siblings('.product-quantity--input');
    var currentValue = parseInt($input.val(), 10);

    if (currentValue > 1) {
      $input.val(currentValue - 1);
    }
  });

  $('.btn-plus').on('click', function() {
    var $input = $(this).siblings('.product-quantity--input');
    var currentValue = parseInt($input.val(), 10);

    $input.val(currentValue + 1);
  });
  
  $('.product-main-media').slick({
    infinite: false,
    prevArrow: '<button class="fa fa-angle-left"></button>',
    nextArrow: '<button class="fa fa-angle-right"></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    vertical: false,
    verticalSwiping: false
  });

  $('.buy-it-with-list').slick({
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.text-img-slider-list').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });

  $(".custom-featured-collection-tabs").each(function() {
    var xyz = $(this);
    var xyzId = xyz.attr('id');
    
    $("#" + xyzId + ' .tab-link').on('click', function() {
      $("#" + xyzId + " .tab-link").removeClass("activetab");
      $(this).addClass("activetab");
      
      var tabId = $(this).data('tab');
      
      $("#" + xyzId + ' .tab-content').hide();
      $("#" + xyzId + " .tab-content").removeClass("active-content-tab");

      $("#" + xyzId + ' #' + tabId).show();
      $("#" + xyzId + ' #' + tabId).addClass("active-content-tab");

      $("#" + xyzId + ' .custom_feature_coll_slider').slick("refresh");
    });
  });

  $('.custom_feature_coll_slider').slick({
    arrows:true,
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          arrows:false,
          dots: true
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
           dots: true
        }
      }
    ]
  });

  $('.testimonials-list-slider').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    appendArrows: '.testimonial_arrows',
    prevArrow: '<div class="arrow-btn pre-btn"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.22144 11.3442L10.6256 20.3046C10.7825 20.4542 10.991 20.5376 11.2078 20.5376C11.4245 20.5376 11.633 20.4542 11.7899 20.3046L11.8001 20.2944C11.8764 20.2219 11.9372 20.1346 11.9787 20.0379C12.0202 19.9412 12.0417 19.837 12.0417 19.7317C12.0417 19.6264 12.0202 19.5222 11.9787 19.4255C11.9372 19.3287 11.8764 19.2414 11.8001 19.1689L2.94433 10.7317L11.8001 2.29781C11.8764 2.22529 11.9372 2.13801 11.9787 2.04126C12.0202 1.94451 12.0417 1.84033 12.0417 1.73504C12.0417 1.62976 12.0202 1.52557 11.9787 1.42883C11.9372 1.33208 11.8764 1.24479 11.8001 1.17228L11.7899 1.16215C11.633 1.01257 11.4245 0.929125 11.2078 0.929125C10.991 0.929125 10.7825 1.01257 10.6256 1.16215L1.22144 10.1225C1.13873 10.2013 1.07289 10.2961 1.0279 10.4011C0.982915 10.5061 0.959717 10.6191 0.959717 10.7334C0.959717 10.8476 0.982915 10.9606 1.0279 11.0656C1.07289 11.1706 1.13873 11.2654 1.22144 11.3442Z" fill="black"/></svg></div>',
    nextArrow: '<div class="arrow-btn nxt-btn"><svg width="13" height="21" viewBox="0 0 13 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.78 11.3442L2.37588 20.3046C2.21896 20.4542 2.01049 20.5376 1.7937 20.5376C1.57692 20.5376 1.36845 20.4542 1.21154 20.3046L1.20141 20.2944C1.12508 20.2219 1.0643 20.1346 1.02276 20.0379C0.981229 19.9412 0.95981 19.837 0.95981 19.7317C0.95981 19.6264 0.981229 19.5222 1.02276 19.4255C1.0643 19.3287 1.12508 19.2414 1.20141 19.1689L10.0571 10.7317L1.20141 2.29781C1.12508 2.22529 1.0643 2.13801 1.02276 2.04126C0.981229 1.94451 0.95981 1.84033 0.95981 1.73504C0.95981 1.62976 0.981229 1.52557 1.02276 1.42883C1.0643 1.33208 1.12508 1.24479 1.20141 1.17228L1.21154 1.16215C1.36845 1.01257 1.57692 0.929125 1.7937 0.929125C2.01049 0.929125 2.21896 1.01257 2.37588 1.16215L11.78 10.1225C11.8627 10.2013 11.9286 10.2961 11.9736 10.4011C12.0186 10.5061 12.0417 10.6191 12.0417 10.7334C12.0417 10.8476 12.0186 10.9606 11.9736 11.0656C11.9286 11.1706 11.8627 11.2654 11.78 11.3442Z" fill="black"/></svg></div>',
    responsive: [
       {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      }
    ]
  });

  $(window).resize(function() {
    //ShoppingPerksSlider();
    $('.custom_feature_coll_slider').slick("refresh");
    related();
  });
    
  setTimeout(function(){
    $('.product_slider').slick('resize');
    $('.buy-it-with-list').slick('resize');
  }, 1000);

  $('.topic__howto').slick({
    dots: true,
    infinite: true,
    prevArrow: '<button class="fa fa-angle-left"></button>',
    nextArrow: '<button class="fa fa-angle-right"></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  
  // slider adpative height 
 $('.topic__howto').on('afterChange', animateHeightMultiElemental );
    $('.topic__howto').on('init', animateHeightMultiElemental );
     console.log("yesss");
   var animateHeightMultiElemental = function(event, slick, currentSlide, nextSlide) {
    debugger;
    var _ = slick;
    var targetHeight = 0;
    var $activeSlides;
    if (_.options.adaptiveHeight === true && _.options.vertical === false) {
        $activeSlides = _.$slideTrack.find('.slick-active');
        $activeSlides.each(function() {
            var height = $(this).outerHeight(true);
            if (targetHeight < height) {
                targetHeight = height;
            }
        });
        _.$list.animate({
            height: targetHeight
        }, _.options.speed);
    }
}
// slider adpative height end code
  $('.topic__hair').slick({
    infinite: true,
       prevArrow: '<button class="fa fa-angle-left"></button>',
    nextArrow: '<button class="fa fa-angle-right"></button>',
   slidesToShow: 2,
slidesToScroll: 1,
arrows: true,
dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

//************cookie of popup js email popup************
function getCookie(cname) {
var name = cname + "=";
var ca = document.cookie.split(';');
for (var i = 0; i < ca.length; i++) {
var c = ca[i];
while (c.charAt(0) == ' ') {
c = c.substring(1);
}
if (c.indexOf(name) == 0) {
return c.substring(name.length, c.length);
}
}
return "";
}
//************/ popup js email popup ************//
function setCookie(cname, cvalue, exdays) {
var d = new Date();
// 1 minute = 60 * 1000
d.setTime(d.getTime() + (exdays*24*60*60*1000));
var expires = "expires=" + d.toUTCString();
document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// check if popupCookie is set or not and hide popup form if popupCookie is set
window.addEventListener('load', (event) => {
// if(getCookie('popupCookie') != 'submited'){
//  $("#custom_popup").show();
//  $("body.template--index").addClass("popup_visible");
// }
const checkpopupval = localStorage.getItem('popup');
  if(checkpopupval == 'submitted'){
  $("#custom_popup").hide();
   $("body.template--index").removeClass("popup_visible");
 }
});
 //sets the coookie to 24hrs if the popup is submited (whole numbers = days)
 $(document).on("click",".close_popup",function(){
   $(".custom_popup").fadeOut(1000);
   setCookie('popupCookie', 'submited');
   $("#custom_popup").hide();
    $("body.template--index").removeClass("popup_visible");
 });
 //permanent created if subscribe
 $(".submit_btn_popup").click(function(){
   localStorage.setItem('popup', 'submitted');
   $("#custom_popup").hide();
   $("body.template--index").removeClass("popup_visible");
});

}); //************************************ready function close*****************************************************//